import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import "./App.css";
import { Loader, ClayLoader } from "./components/loader";

// Lazy-load Demo component
const Demo = lazy(() =>
  import("./components/demo").then((module) => ({ default: module.Demo }))
);

// Invalid URL fallback
function InvalidUrl() {
  return (
    <div className="App">
      <p>Invalid URL</p>
    </div>
  );
}

// Loading screen that uses useParams safely within a wrapper
function LoadingPageWrapper() {
  return <LoadingPageContent />;
}

function LoadingPageContent() {
  const { accountId } = useParams();
  if (["DepraccGQmzZCRXkU"].includes(accountId)) {
    return <ClayLoader isLoading={true} />;
  } else {
    return <Loader isLoading={true} />;
  }
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<Loader isLoading={true} />}>
          <Routes>
            <Route path="/" element={<InvalidUrl />} />
            <Route path="/:accountId/:demoId" element={<Demo />} />
            <Route path="/:linkId" element={<Demo />} />
            {/* optional catch-all */}
            <Route path="*" element={<InvalidUrl />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;

